// extracted by mini-css-extract-plugin
export default {"tabPanel":"AddToMediaGroupIconButton_tabPanel__4bmc0"};